<template>
  <div class="accountPage">
    <div class="toolBar">
      <div class="textBox">账号管理</div>
      <div class="btnBox">
        <el-button
          type="primary"
          @click.native.prevent="addAccount"
          size="small"
          >+添加账号</el-button
        >
      </div>
    </div>
    <div class="tableBox">
      <el-table
        :data="accData"
        border
        style="width: 100%"
        :cell-class-name="'cellClass'"
        :stripe="true"
         v-loading = "isLoading"
      >
        <el-table-column
          :key="'email'"
          :prop="'email'"
          :label="'用户名'"
        ></el-table-column>
        <el-table-column :key="'role'" :prop="'role'" :label="'角色'">
        </el-table-column>
        <el-table-column :key="'passw'" :prop="'password'" :label="'密码'">
          <template slot-scope="scope">
            <el-input
              placeholder=""
              v-model="scope.row.password"
              show-password
              size="small"
              :disabled="true"
            ></el-input>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="240">
          <template slot-scope="scope">
            <el-button
              @click.native.prevent="viewAccount(scope.$index)"
              plain
              size="small"
            >
              查看
            </el-button>
            <el-button
              @click.native.prevent="editAccount(scope.$index)"
              plain
              size="small"
            >
              修改
            </el-button>

            <el-popconfirm
              title="确定删除此条记录吗？"
              @confirm="deleteAccount(scope.$index)"
            >
              <el-button slot="reference" type="danger" size="small"
                >删除</el-button
              >
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <add-pop
      v-if="showPop"
      @save="save"
      @close="close"
      :rowData="rowData"
      :showView="showView"
    ></add-pop>
  </div>
</template>

<script>
import addPop from "./pop/addPop.vue";
import {
  getAccountList,
  setAccount,
  delAccount,
  addAccount,
} from "../../api/process";
import { Message } from "element-ui";
export default {
  name: "accountManage",
  components: { addPop },
  data() {
    return {
      isLoading:false,
      showPop: false,
      saveData: "",
      showView: false,
      rowData: "",
      accData: [
        // {
        //   email: "战三",
        //   password: "121212",
        //   role:"超级管理员"
        // },
        // {
        //   email: "战为i",
        //   password: "121212",
        //   role:"入库"
        // },
        // {
        //   email: "战流",
        //   password: "121212",
        //   role:"品控"
        // },
      ],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    editAccount(index) {
      this.showView = false;
      this.showPop = true;
      this.rowData = this.accData[index];
    },
    viewAccount(index) {
      this.rowData = this.accData[index];
      this.showView = true;
      this.showPop = true;
    },
    addAccount() {
       this.showView = false;
      this.rowData = "";
      this.showPop = true;
    },
    deleteAccount(index) {
      let that=this
      delAccount({id:this.accData[index].id})
        .then((res) => {
          Message.success("删除成功");
          that.getList()
        })
        .catch((e) => {
          Message.fail(e.msg);
        });
    },
    save(data) {
      // this.saveData = data;
      data['id']=this.rowData.id
      // data['username']=data.email
      // delete data['email']
      let that=this
      if (this.rowData) {
        //修改
        setAccount(data)
          .then((res) => {
            Message.success("修改成功");
            that.getList()
          })
          .catch((e) => {
            Message.fail(e.msg);
          });
      } else {
        //新增
        addAccount(data)
          .then((res) => {
            Message.success("新增用户成功");
            that.getList()
          })
          .catch((e) => {
            Message.fail(e.msg);
          });
      }

      this.showPop = false;
    },
    getList() {
      let that=this
      that.isLoading=true
      getAccountList()
        .then((res) => {
          let list = res.dataList;
          list.map((item, index) => {
            if (item.role_id == 0) {
              item.role = "超级管理员";
            }else if(item.role_id == 1){
              item.role = "数据看板";
            }
          });
          this.accData = res.dataList;
           that.isLoading=false
        })
        .catch((e) => {
          console.log(e);
          that.isLoading=false
        });
    },
    close() {
      this.showPop = false;
    },
  },
};
</script>

<style lang="less">
.accountPage {
  .toolBar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/userManage/index.vue